const getState = () => {
  return {
    historyList: [],
    collapse: false,
    locale: ""
  };
};
const state = getState();


const mutations = {
  PUSH_LIST: (state, val) => {
    // console.log(val)
    let flag = false;
    state.historyList.forEach((item) => {
      if (item.name == val.name) {
        flag = true;
      //   item.active = true;
      // } else {
      //   item.active = false;
      }
      item.active=(item.name == val.name)
    });
    if (!flag) {
      state.historyList.push({
        name: val.name,
        fullPath: val.fullPath,
        index: state.historyList.length,
        type: 1,
        active: true,
      });
    }
  },
  REMOVE_LIST: (state, val) => {
    // state.historyList.splice(val.index, 1);
    let removeIndex=-1
    state.historyList.forEach((v,index)=>{
      if(v.name===val.name){
        removeIndex=index
      }
    })
    if(removeIndex>-1){
      state.historyList.splice(removeIndex, 1);
    }
  },
  RESET_LIST: (state) => {
    state.historyList = [];
  },
  SET_LOCALE: (state, val) => {
    state.locale = val || 'zh-cn';
    localStorage.setItem('language', val || 'zh-cn')
  },
  SET_COLLAPSE: (state, val) => {
    state.collapse = val;
  },
};
const actions = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
